import { ReactNode } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import { Text, TTextLocalized } from '@northladder/i18n';

import { THeroIcon } from '../../types';

interface IContentErrorViewProps {
  children?: ReactNode;
  icon?: THeroIcon;
  subTitle: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * Provides options for displaying an error content view when the user which can
 * be customized by the parent component.
 */
export function ContentErrorView({
  children,
  subTitle,
  title,
  icon: Icon = ExclamationCircleIcon,
}: IContentErrorViewProps) {
  return (
    <div className="flex min-h-[calc(100vh-15rem)] flex-col justify-center">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          className="
            shadow-xs bg-white px-4 py-8 dark:bg-gray-900/50
            sm:rounded-3xl sm:px-10
          "
        >
          <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
            <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
              <Icon
                aria-hidden="true"
                className="
                  bg-primary-50 mx-auto my-12 h-16
                  w-16 rounded-full  p-4 text-red-700 dark:bg-red-500/10 dark:text-red-600
                "
              />
              <h1
                className="
                  mt-4 text-xl font-normal tracking-tight text-red-700
                  dark:text-red-200 sm:text-xl
                "
              >
                <Text text={title} />
              </h1>
              <p className="text-primary-900 my-8 max-w-xl font-light dark:text-gray-200">
                <Text text={subTitle} />
              </p>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
